module.exports = __webpack_public_path__ + "img/PS-J-16.208498dd.svg";